export enum DenunciaTipoEnum {

  Rps
}
